import useSWR from 'swr'
import { jsonGetFetcher } from '../src/fetchers'

function useFeedUnread (token, challengeId) {
  let url = `${process.env.API}/feeds/challenge/${challengeId}/unread`
  
  const defaultHook = {
    loading: false,
    data: [],
    error: false
  }

  let { data, error } = useSWR(token && challengeId ? [url, token] : null, jsonGetFetcher, {
    refreshInterval: (30 * 1000),
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    dedupingInterval: 30000,
    focusThrottleInterval: 30000
  })

  if (!data && !error) return { ...defaultHook, loading: true }

  if (error) {
    console.error(error)
    return { ...defaultHook, error: error.message, loading: false }
  }

  return { ...defaultHook, loading: false, data }
}

export default useFeedUnread
